import { gql, useLazyQuery } from "@apollo/client";
import { useCallback, useMemo } from "react";

export const GetClassRoomsWhereTeacherWasCandidateQuery = gql`
  query getClassRoomsWhereTeacherWasCandidate(
    $teacherId: String!
    $classRoomIds: [String!]!
  ) {
    getClassRoomsWhereTeacherWasCandidate(
      teacherId: $teacherId
      classRoomIds: $classRoomIds
    )
  }
`;

export type GetClassRoomsWhereTeacherWasCandidateQueryResult = {
  getClassRoomsWhereTeacherWasCandidate: string[];
};

export function useTeacherCandidateClassRooms() {
  const [fetch, { data, loading }] =
    useLazyQuery<GetClassRoomsWhereTeacherWasCandidateQueryResult>(
      GetClassRoomsWhereTeacherWasCandidateQuery,
      { fetchPolicy: "cache-and-network" },
    );

  const fetchCandidateRooms = useCallback(
    (teacherId: string, classRoomIds: string[]) =>
      fetch({ variables: { teacherId, classRoomIds } }),
    [fetch],
  );

  const candidateClassRoomIds = useMemo(
    () => new Set(data?.getClassRoomsWhereTeacherWasCandidate ?? []),
    [data],
  );

  return {
    fetchCandidateRooms,
    candidateClassRoomIds,
    loading,
  };
}
